export const defaultMenuList = () => [
	{
		id: 1,
		name: 'Informações Pessoais',
		tag: 'customer',
		active: true,
		completed: false,
		skiped: false,
		editing: false,
	},
	{
		id: 2,
		name: 'Empreendimento de Interesse',
		tag: 'product',
		active: false,
		completed: false,
		skiped: false,
		editing: false,
	},
	{
		id: 3,
		name: 'Etapa e Status',
		tag: 'status-stage',
		active: false,
		completed: false,
		skiped: false,
		editing: false,
	},
	{
		id: 4,
		name: 'Responsável',
		tag: 'responsible',
		active: false,
		completed: false,
		skiped: false,
		editing: false,
	},
]

export const defaultActionList = () => [
	{
		id: 1,
		name: 'Visualizar dados do Cliente',
		action: 'redirect--client',
		check: false,
	},
	{
		id: 2,
		name: 'Criar uma Tarefa',
		action: 'redirect--make-task',
		check: false,
	},
	{
		id: 3,
		name: 'Solicitar uma Reserva',
		action: 'redirect--make-reserve',
		check: false,
	},
]
